module.exports = __webpack_public_path__ + "static/img/アセット 77@3x.dbf54b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/アセット 77@3x.png
// module id = iMA2
// module chunks = 1